import React from "react";
import { useInstrument } from "../context/InstrumentContext";

/**
 * Segmented tab showing the user's instruments.
 * Hidden entirely when the user only has one instrument — no visual clutter.
 */
export default function InstrumentTabs({ className = "" }) {
  const { instruments, current, setCurrent, label, emoji } = useInstrument();
  if (!instruments || instruments.length <= 1) return null;

  return (
    <div className={`bento-card p-2 inline-flex flex-wrap gap-1 ${className}`} data-testid="instrument-tabs">
      {instruments.map((k) => {
        const active = k === current;
        return (
          <button
            key={k}
            onClick={() => setCurrent(k)}
            data-testid={`instrument-tab-${k}`}
            className="rounded-xl px-3 py-1.5 text-sm font-semibold transition-colors inline-flex items-center gap-2"
            style={{
              background: active ? "var(--app-primary)" : "transparent",
              color: active ? "#fff" : "var(--app-text)",
            }}
          >
            <span>{emoji(k)}</span>
            <span>{label(k)}</span>
          </button>
        );
      })}
    </div>
  );
}
